/*
Infinite scroll — Periscope Depth
Continuously loads posts as the user scrolls. Uses IntersectionObserver
to detect when the last post enters the viewport, then fetches the next
page and appends posts.

Requires: each card must have the `post` class; the container must be
`.gh-postfeed`.
*/

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

// Fetch and parse next page
async function getNextPage(url) {
    const res = await fetch(url);

    if (!res.ok) {
        throw new Error(`Failed to fetch page: ${res.status}`);
    }

    const nextPageHtml = await res.text();
    const parser = new DOMParser();
    const parsed = parser.parseFromString(nextPageHtml, 'text/html');
    const posts = parsed.querySelectorAll('.post');
    const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');

    return { posts, nextLink };
}

export default function infiniteScroll() {

    if (!link) { return; }

    const feed = document.querySelector('.gh-postfeed');
    if (!feed) { return; }

    let loading = false;

    const options = {
        // Trigger 150px before the last card enters the viewport
        rootMargin: '150px',
    };

    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting || loading || !link) return;

            loading = true;
            observer.unobserve(entry.target);

            getNextPage(link).then(({ posts, nextLink }) => {
                posts.forEach(post => feed.append(post));

                if (nextLink) {
                    link = nextLink;
                    const lastPost = feed.querySelector('.post:last-of-type');
                    if (lastPost) observer.observe(lastPost);
                } else {
                    observer.disconnect();
                }
            }).catch(err => {
                console.error('Infinite scroll error:', err);
            }).finally(() => {
                loading = false;
            });
        });
    };

    const observer = new IntersectionObserver(callback, options);
    const lastPost = feed.querySelector('.post:last-of-type');
    if (lastPost) observer.observe(lastPost);
}